module.exports = __webpack_public_path__ + "static/a_frame.d2351b46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/a_frame.jpg
// module id = 578
// module chunks = 35783957827783